import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section id="recensioni" className="py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-primary-400"></span>
            <span className="text-xs text-foreground-500 tracking-wider uppercase font-medium">
              Community
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
            Opinioni Reali
          </h2>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-primary-500 leading-tight mt-1">
            Su Itaobuy
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-4 max-w-xl mx-auto">
            Cosa dicono gli utenti italiani che utilizzano Itaobuy Spreadsheet ogni giorno.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl border border-background-200/70 p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`text-sm ${
                        i < t.rating
                          ? 'ri-star-fill text-amber-400'
                          : 'ri-star-line text-background-300'
                      }`}
                    ></i>
                  </span>
                ))}
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
                {t.title}
              </h4>
              <p className={`text-sm leading-relaxed flex-1 mb-5 ${idx >= 4 ? 'text-foreground-400' : 'text-foreground-600'}`}>
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-xs font-semibold">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}